import { useDestinationContext } from '@/src/contexts'

import TopHotels from './topHotels'

const TopHotelsWrapper = () => {
    const { destinationData: { sections } } = useDestinationContext()
    const hotels = sections.topHotels
    if (!hotels?.length) return null

    return <TopHotels hotels={hotels} />
}

export default TopHotelsWrapper
